import { type ReactNode } from 'react'
import { PublicHeader, type PublicHeaderProps } from './PublicHeader'
import { PublicFooter } from './PublicFooter'

export interface PublicLayoutProps extends PublicHeaderProps {
  children: ReactNode
}

export function PublicLayout({ children, ...headerProps }: PublicLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background font-sans text-foreground">
      <PublicHeader {...headerProps} />
      <main className="flex-grow">{children}</main>
      <PublicFooter />
    </div>
  )
}
